import { CSSProperties, FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cloudStorage } from '@telegram-apps/sdk-react';

import UIConfig from '@/UIConfig.ts';
import { ProfileCloudKeys } from '@/enums/storageEnums.ts';

interface TabBarProps {
  activeTabIndex: number;
  handleTabChange: (index: number) => void;
}

const TabBar: FC<TabBarProps> = ({ activeTabIndex, handleTabChange }) => {
  const { t } = useTranslation();
  const [showDot, setShowDot] = useState(false);

  useEffect(() => {
    const checkVisitedFlag = async () => {
      try {
        const visited = await cloudStorage.getItem(
          ProfileCloudKeys.MY_SPACE_VISITED
        );

        if (visited === 'true') {
          setShowDot(false);
        } else {
          setShowDot(true);
        }
      } catch (err) {
        setShowDot(true);
      }
    };

    void checkVisitedFlag();
  }, []);

  const handleTabClick = async (index: number) => {
    handleTabChange(index);

    if (index === 1 && showDot) {
      try {
        await cloudStorage.setItem(ProfileCloudKeys.MY_SPACE_VISITED, 'true');
      } catch (err) {
        /* error */
      }
      setShowDot(false);
    }
  };

  return (
    <div style={containerStyle}>
      <div style={innerContainerStyle}>
        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 0 ? activeTabStyle : inactiveTabStyle)
          }}
          onClick={() => handleTabClick(0)}
        >
          {t('profile.get_more')}
        </div>

        <div
          style={{
            ...tabStyle,
            ...(activeTabIndex === 1 ? activeTabStyle : inactiveTabStyle),
            position: 'relative'
          }}
          onClick={() => handleTabClick(1)}
        >
          <span style={{ position: 'relative' }}>
            {t('profile.my_space')}
            {showDot && <div style={unreadDotStyle} />}
          </span>
        </div>
      </div>
    </div>
  );
};

const containerStyle: CSSProperties = {
  display: 'flex',
  width: '100%',
  background: UIConfig.Colors.BackgroundWhite,
  padding: '0',
  justifyContent: 'center',
  zIndex: 100,
  marginTop: '-40px'
};

const innerContainerStyle: CSSProperties = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '15px',
  width: 'calc(100% - 42px)'
};

const tabStyle: CSSProperties = {
  display: 'inline-block',
  padding: '8px 0',
  fontSize: '15px',
  fontWeight: '600',
  cursor: 'pointer',
  textAlign: 'center',
  transition: 'color 0.3s ease',
  position: 'relative',
  flex: '1'
};

const activeTabStyle: CSSProperties = {
  color: '#000',
  width: 'calc(50% - 10px)',
  borderBottom: '3px solid black'
};

const inactiveTabStyle: CSSProperties = {
  color: '#888',
  borderBottom: 'none'
};

const unreadDotStyle: CSSProperties = {
  position: 'absolute',
  top: '-5px',
  right: '-10px',
  width: '6px',
  height: '6px',
  backgroundColor: '#851989',
  borderRadius: '50%'
};

export default TabBar;
